import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-GDesign";
import leftimg from "../../../assets/adobeleftimg.png";
import rightimg from "../../../assets/adoberightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/corel-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/corel-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/corel-benefit-img3.jpg";
import BenefitsDataImg4 from "../../../assets/corel-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/corel-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/corel-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/corel-benefit-img7.png";
import BenefitsDataImg8 from "../../../assets/BenefitsDataImg8.png";
import BenefitsDataImg9 from "../../../assets/corel-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/corelFun-img1.png";
import FunactivitiesImg2 from "../../../assets/corelFun-img2.png";
import FunactivitiesImg3 from "../../../assets/corelFun-img3.png";
import FunactivitiesImg4 from "../../../assets/corelFun-img4.png";
import FunactivitiesImg5 from "../../../assets/corelFun-img5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "09",
      classes: "07",
      description:" Introduction to Graphic Designing- Learn design principles, image sourcing, file formats, and explore online design marketplaces.",
    },
    {
      title: "Module 2",
      activities: "09",
      classes: "07",
      description:" Photoshop Basics-  Understand Photoshop tools and layers, including selection, crop, pen, brush, and erase.",
    },
    {
      title: "Module 3",
      activities: "09",
      classes: "06",
      description:"Photoshop Intermediate- Use adjustment panels and gradients, and learn to colorize black-and-white images.",
    },
    {
      title: "Module 4 ",
      activities: "09",
      classes: "09",
      description:" Photoshop Advanced-  Master advanced editing, and design logos, CVs, flyers, and custom social media avatars.", 
    }
];    

  const benefitsData = [
      {
        title: "Graphic Design Basics",
        description: "Understand tools, layouts, and design flow.",
        icon: BenefitsDataImg1,
      },
      {
        title: "Design Principles",
        description: "Master alignment, contrast, and balance.",
        icon: BenefitsDataImg2,
      },
      {
        title: "Photoshop Essentials",
        description: "Learn basic tools and workspace navigation.",
        icon: BenefitsDataImg3,
      },
      {
        title: " Advanced Photoshop ",
        description: "Explore layers, masks, and smart objects.",
        icon: BenefitsDataImg4,
      },
      {
        title: "Adjustment Panels & Gradients",
        description: "Fine-tune color, light, and blending",
        icon: BenefitsDataImg5,
      },
      {
        title: "Photo Colorization",
        description: "Turn black & white images into vivid color.",
        icon: BenefitsDataImg6,
      },
      {
        title: "CV, Logo & Flyer Design",
        description: "Build professional assets for career and branding.",
        icon: BenefitsDataImg7,
      },
      {
        title: "Personalized Avatars",
        description: "Create custom social media profile images.",
        icon: BenefitsDataImg8,
      },
      {
        title: "Sticker Pack Creation",
        description: "Design fun and sharable sticker sets.",
        icon: BenefitsDataImg9,
      },
    ];
    const activitiesData = [
        {
          title: "Business Card",
          image: FunactivitiesImg1,
        },
        {
          title: "Flyers",
          image: FunactivitiesImg2,
        },
        {
          title: "Logos",
          image: FunactivitiesImg3,
        },
        {
          title: "Book Covers",
          image: FunactivitiesImg4,
        },
        {
          title: "Brochures",
          image: FunactivitiesImg5,
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "", // Replace with the actual video URL
  };
const PhotoShop = () => {
  const PhotoShoppage = heroContent.photoshopsection;
  return (
    <>
       <GuestNav/>
     <Hero2
        titlePart1={PhotoShoppage.titlePart1}
        // titlePart2={adobepage.titlePart2}
        description={PhotoShoppage.description}
        buttonText={PhotoShoppage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
       <CourseTimeline
        title="Course Structure and Syllabus"
        modules={beginnerModules}
      />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Corel Draw"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default PhotoShop